import { apiClient, downloadFile } from './client';

const BASE = '/api/reports/events';

export const eventsApi = {
  getAll: async ({ skip = 0, limit = 20, status_filter, search, date_from, date_to, sort } = {}, config = {}) => {
    const params = { skip, limit };
    if (status_filter) params.status_filter = status_filter;
    if (search) params.search = search;
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;
    if (sort) params.sort = sort;
    const response = await apiClient.get(`${BASE}/`, { ...config, params });
    return response.data;
  },

  /** Distinct values for the list filter dropdowns. */
  getFacets: async (config = {}) => {
    const response = await apiClient.get(`${BASE}/facets`, config);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`${BASE}/${id}`);
    return response.data;
  },

  update: async (id, eventData) => {
    const response = await apiClient.put(`${BASE}/${id}`, eventData);
    return response.data;
  },

  /** Start an event report run (`report_kind` 'full' | 'daily'). */
  generateReport: async (id, {
    questions = [],
    chatbot = true,
    qa = true,
    graph = true,
    push_to_wordpress = false,
    faicon_post_id,
    chatbot_id,
    cover_image_url,
    report_kind = 'full',
    day_number,
    take_official = true,
  } = {}) => {
    const body = { questions, chatbot, qa, graph, push_to_wordpress, report_kind, take_official };
    if (faicon_post_id) body.faicon_post_id = faicon_post_id;
    if (chatbot_id) body.chatbot_id = chatbot_id;
    if (cover_image_url) body.cover_image_url = cover_image_url;
    if (report_kind === 'daily' && day_number) body.day_number = day_number;
    const response = await apiClient.post(`${BASE}/${id}/generate-report`, body);
    return response.data;
  },

  listReports: async (id) => {
    const response = await apiClient.get(`${BASE}/${id}/reports`);
    return response.data;
  },

  setReportOfficial: async (id, reportId) => {
    const response = await apiClient.post(`${BASE}/${id}/reports/${reportId}/set-official`);
    return response.data;
  },

  /** Without `reportId` the official report is used. */
  getReportStatus: async (id, reportId = null) => {
    const response = await apiClient.get(`${BASE}/${id}/report/status`, {
      params: reportId ? { report_id: reportId } : undefined,
    });
    return response.data;
  },

  getReport: async (id, reportId = null) => {
    const response = await apiClient.get(`${BASE}/${id}/report`, {
      params: reportId ? { report_id: reportId } : undefined,
    });
    return response.data;
  },

  publishToFaicon: async (id) => {
    const response = await apiClient.post(`${BASE}/${id}/send-faicon`);
    return response.data;
  },

  /**
   * `apiVersion` is the DigWatch preset ('production' | 'v5' | 'v6'). The sessions
   * part is always sent; `sections` toggles analytics, graph, chatbot and Q&A.
   */
  publishToWordPress: async (id, apiVersion = 'production', sections = null, reportId = null) => {
    const body = sections
      ? {
          include_analytics: sections.include_analytics !== false,
          include_graph: sections.include_graph !== false,
          include_chatbot: sections.include_chatbot !== false,
          include_qa: sections.include_qa !== false,
        }
      : null;
    const response = await apiClient.post(`${BASE}/${id}/send-wordpress`, body, {
      params: { api_version: apiVersion, ...(reportId ? { report_id: reportId } : {}) },
    });
    return response.data;
  },

  downloadReportPdf: async (id) => {
    await downloadFile(`${BASE}/${id}/report/pdf`, {
      fallbackName: `event_report_${id}.pdf`,
      mimeType: 'application/pdf',
    });
  },
};
